<template>
  <!-- 儲存下載：顯示本次選配結果 ＋ 紙本提醒；footer =「回上一步 / 確定」-->
  <div class="ur-sel-modal-overlay" @click.self="$emit('close')">
    <div class="ur-sel-modal-box">
      <div class="ur-sel-result-body">
        <div class="ur-sel-result-title">{{ $t('URBANRENEWAL_SELECT.DIALOG.RESULT_TITLE') }}</div>

        <div class="ur-sel-result-card">
          <div class="ur-sel-result-row">
            <span>{{ $t('URBANRENEWAL_SELECT.DIALOG.RESULT_OWNER') }}</span>
            <span class="ur-sel-result-strong">{{ ownerNames }}</span>
          </div>

          <div v-if="picked.length === 0" class="ur-sel-result-row ur-sel-result-empty">
            <span>{{ $t('URBANRENEWAL_SELECT.DIALOG.RESULT_EMPTY') }}</span>
          </div>
          <div v-for="(p, i) in picked" :key="i" class="ur-sel-result-row">
            <span><span class="ur-sel-result-type">{{ p.label }}</span>{{ p.code }}</span>
            <span class="ur-sel-result-num">{{ fmtMoney(p.price) }}</span>
          </div>

          <div class="ur-sel-result-divider"></div>

          <div class="ur-sel-result-row">
            <span>{{ noColon($t('URBANRENEWAL_SELECT.PANEL.SELECT_TOTAL')) }}</span>
            <span class="ur-sel-result-strong ur-sel-result-num">{{ fmtMoney(total) }}</span>
          </div>
          <div class="ur-sel-result-row">
            <span>{{ noColon(makeupLabel) }}</span>
            <span
              class="ur-sel-result-strong ur-sel-result-num"
              :class="makeupStatus === 'pay' ? 'is-pay' : 'is-refund'"
            >{{ fmtMoney(Math.abs(makeup)) }}</span>
          </div>
        </div>

        <p class="ur-sel-result-reminder">{{ $t('URBANRENEWAL_SELECT.DIALOG.SAVE_BODY') }}</p>
      </div>

      <div class="ur-sel-modal-footer">
        <button class="ur-sel-modal-btn ur-sel-modal-btn-secondary" type="button" @click="$emit('close')">
          {{ $t('URBANRENEWAL_SELECT.DIALOG.SAVE_CANCEL') }}
        </button>
        <button class="ur-sel-modal-btn ur-sel-modal-btn-primary" type="button" @click="$emit('confirm')">
          {{ $t('URBANRENEWAL_SELECT.DIALOG.SAVE_CONFIRM') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moneyFormat from '../moneyFormat';

export default {
  name: 'UrbanRenewalSelectSaveConfirmDialog',

  mixins: [moneyFormat],

  props: {
    owners: { type: Array, default: () => [] },
    housing: { type: Array, default: () => [] },
    parking: { type: Array, default: () => [] },
    total: { type: Number, default: 0 },
    makeup: { type: Number, default: 0 },
    makeupStatus: { type: String, default: 'none' },
  },

  computed: {
    ownerNames() {
      return this.owners.map(o => o.display_name).join('、') || '-';
    },

    picked() {
      const rows = this.housing.map(u => ({
        label: this.$t('URBANRENEWAL_SELECT.DIALOG.RESULT_HOUSE'), code: u.unit_code, price: u.total_price || 0,
      }));
      this.parking.forEach(u => rows.push({
        label: this.$t('URBANRENEWAL_SELECT.DIALOG.RESULT_PARK'), code: u.unit_code, price: u.value || 0,
      }));
      return rows;
    },

    makeupLabel() {
      if (this.makeupStatus === 'refund') return this.$t('URBANRENEWAL_SELECT.PANEL.MAKEUP_REFUND');
      if (this.makeupStatus === 'pay') return this.$t('URBANRENEWAL_SELECT.PANEL.MAKEUP_PAY');
      return this.$t('URBANRENEWAL_SELECT.PANEL.MAKEUP_NONE');
    },
  },

  methods: {
    noColon(s) {
      return String(s == null ? '' : s).replace(/[：:]\s*$/, '');
    },
  },
};
</script>
